import { render, staticRenderFns } from "./ebookReview.vue?vue&type=template&id=8b96aac0&scoped=true&"
import script from "./ebookReview.vue?vue&type=script&lang=js&"
export * from "./ebookReview.vue?vue&type=script&lang=js&"
import style0 from "./ebookReview.vue?vue&type=style&index=0&id=8b96aac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b96aac0",
  null
  
)

export default component.exports